import { useQuery } from '@tanstack/react-query';

import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';

import { apiGetQueryKeys } from '../api';
import { SEARCH_QUERY_KEYS } from '../constants';

export const useLoadQueryKeys = (isEnabled: boolean = true) => {
    const { data, isLoading, error } = useQuery({
        queryKey: [SEARCH_QUERY_KEYS.QUERY_KEYS],
        queryFn: ({ signal }) => apiGetQueryKeys(signal),
        select: (response) => (typeof response === 'object' ? response : undefined),
        enabled: isEnabled,
        staleTime: Infinity,
    });
    useLogError(error, DDComponent.Search);

    return { isLoading, queryKeys: data };
};
